export function isEqualArray(arr1: unknown[], arr2: unknown[]): boolean {
  return (
    arr1.length === arr2.length &&
    arr1.every((item, index) => item === arr2[index])
  );
}
